import { render, staticRenderFns } from "./AllExercises.vue?vue&type=template&id=45138c36&"
import script from "./AllExercises.vue?vue&type=script&lang=ts&"
export * from "./AllExercises.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports